<template>
    <div>
        <div class="active" v-show="'copydesk-session' == currentStep.key">
            <div class="form-group">
                <label for=""> Channel</label>
                <select class="form-control" name="id_channel">
                    <option value="">Select a channel</option>
                    <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for=""> Session type</label>
                <select class="form-control" name="copy_type">
                    <option value="">Select shoot type</option>
                    <option value="write">Write Session</option>
                    <option value="review">Review Session</option>

                </select>
            </div>
            <div class="form-group">
                <label for=""> Session language</label>
                <select class="form-control" name="id_language">
                    <option value="">Select a language</option>
                    <option v-for="language in languages" :value="language.id_language">{{language.name}}</option>

                </select>
            </div>
        </div>
        <div class="active" v-show="'copydesk-contributors' == currentStep.key">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="users-list-w">
                            <div class="user-w with-status status-green">
                                <div class="user-avatar-w">
                                    <div class="user-avatar"><img alt="" :src="user.avatar"></div>
                                </div>
                                <div class="user-name">
                                    <h6 class="user-title">{{user.name}}</h6>
                                    <div class="user-role">You are the writer for this session</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['currentStep', 'channels', 'categories', 'languages', 'selectedUsers'],
  data () {
    return {
      user: ''
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      this.user = this.$store.getters.authUser
    }
  }
}
</script>
